/* eslint-disable react/require-default-props */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ResizeContext } from '../../../../contexts/Resize/Resize';
import MegaMenu from './MegaMenu';

function MegaMenuVM({
  menuList, width, displayRewardsToolTip, loginStatus, ...filteredProps
}) {
  const { pageYOffset, isScrollingDown } = useContext(ResizeContext);

  /*
    No one has a good explanation as to why `carouselItems` is:
    1. nested inside `children`;
    2. sometimes not there;
    3. sometimes an empty array;
    So, we do this :-(
  */
  const mapProps = menuList.map(({ children = [], title, url }) => {
    const { carouselItems = [] } = children.find(({ carouselItems: items }) => !!items) || {};

    return {
      categoryImages: carouselItems,
      subCategories: children.filter(({ label }) => !!label),
      title,
      url,
    };
  });

  return (
    <MegaMenu
      navData={mapProps}
      {...filteredProps}
      width={width}
      displayRewardsToolTip={displayRewardsToolTip}
      loginStatus={loginStatus}
      pageYOffset={pageYOffset}
      isScrollingDown={isScrollingDown}
    />
  );
}

MegaMenuVM.propTypes = {
  className: PropTypes.string,
  menuLabel: PropTypes.string,
  menuList: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          columnType: PropTypes.string,
          links: PropTypes.arrayOf(
            PropTypes.shape({
              title: PropTypes.string,
              url: PropTypes.string,
            }),
          ),
          carouselImages: PropTypes.arrayOf(
            PropTypes.shape({
              image: PropTypes.string,
              imageAltText: PropTypes.string,
              title: PropTypes.string,
              url: PropTypes.string,
            }),
          ),
        }),
      ),
      title: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
  hideTopHeader: PropTypes.bool,
  width: PropTypes.number,
  displayRewardsToolTip: PropTypes.bool.isRequired,
  loginStatus: PropTypes.bool,
};

export default MegaMenuVM;
